// Owner-authorized port of Aieun Labs StudioCardArt.astro, Chandas branch only.
// Markup, specimen, weights and classes are retained; Jyotir's asset is new.
export default function StudioCardArt({ slug }: { slug: string }) {
  return <div className={`tool-art tool-art-${slug}`} aria-hidden="true">
    {slug === "chandas-shastra" ? <>
      <div className="art-kicker">The architecture of a verse</div>
      <div className="art-chandas-verse" lang="sa">वागर्थाविव सम्पृक्तौ</div>
      <div className="art-chandas-syllables">{[["वा","–"],["ग","–"],["र्था","–"],["वि","◡"],["व","◡"],["स","–"],["म्पृ","–"],["क्तौ","–"]].map(([letter, weight], index) => <span key={index} className={weight === "◡" ? "art-chandas-light" : ""}><strong lang="sa">{letter}</strong><i>{weight}</i></span>)}</div>
      <div className="art-chandas-label"><strong lang="sa">अनुष्टुभ्</strong><span>8 syllables · one pāda<br/><small>Detect. Learn. Compose.</small></span></div>
    </> : <>
      <div className="art-kicker">One Moon. Two measurements.</div>
      <img className="art-jyotir-sky" src="/learning-apps/art/jyotir-vidya.svg" width="420" height="176" alt=""/>
    </>}
  </div>;
}

// Exact existing ArrowIcon.astro path, rendered in React.
export function CatalogueArrow() {
  return <svg className="arrow-icon" width="18" height="18" viewBox="0 0 18 18" aria-hidden="true"><path d="M3 9h11M10 4l5 5-5 5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></svg>;
}
